import styled from 'styled-components'

import { Checkbox } from '@blade/ui-kit'

export const SettingsCheckbox = styled(Checkbox)`
  --checkbox-indicator-background: radial-gradient(
    301.86% 237.26% at -13.04% -45.83%,
    var(--primary-9) 0%,
    var(--primary-4) 100%
  );

  &[aria-checked='true'] {
    border-color: var(--primaryA-8);
  }
`
